import PhotoPool from './PhotoPool'

export default PhotoPool
